<template>
  <div id="container">
    <div
      class="item-box-content"
      style="padding:14px 20px;">
      <div class="title-font-style">
        <span>文件模板管理</span>
      </div>
    </div>

    <div
      class="item-box-content"
      style="margin-bottom: 0"
      :style="{height:tableHeight+'px'}">
      <el-table
        border
        ref="tableRef"
        :data="newtemplateList"
        :max-height="tableHeight"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        v-loading="loadingTable"
        element-loading-text="拼命加载中请稍后..."
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column
          prop="templateName"
          label="模板名称"></el-table-column>
        <el-table-column
          prop="lastDate"
          label="更新时间"></el-table-column>
        <el-table-column
          prop
          label="操作"
          width="200px">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="towatch(scope.row)">预览
            </el-button>
            <el-button
              type="text"
              @click="onExchange(scope.row,1)">修改
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 侧边栏---添加/修改模板 -->
    <join-inquiry-sheet ref="joinInquirySheetRefs"></join-inquiry-sheet>
  </div>
</template>
<script>
  import { expressionList } from '@/components/utils/data'
  import { FileTemplate } from '@/api/system/rightsManagement'
  import joinInquirySheet from '../sliderBar/exchangeTemplate'
  import { formatData } from '@/util/filterCommon'

  export default {
    components: {
      'join-inquiry-sheet': joinInquirySheet
    },
    data () {
      return {
        queryParams: {},
        params: {},
        contractScreenCondition: [],
        expressionList: expressionList,
        loadingTable: false, // 列表loading
        list: [{}], // 列表数据
        value1: false,
        value2: true,
        drawer: false,
        proAllContent: '',
        tableHeight: window.innerHeight - 250,
        templatellist: [
          // {
          //   id: 9,
          //   templateName: '销售合同模板(期货)',
          //   createDate: 1602495748000,
          //   createIp: null,
          //   createUser: null,
          //   templateContent: ''
          // }
          // {
          //   id: 8,
          //   templateName: '采购合同模板',
          //   createDate: 1602495723000,
          //   createIp: 0,
          //   createUser: '',
          //   templateContent: ''
          // }
        ]
      }
    },
    mounted () {
      this.getInit()
    },
    computed: {
      newtemplateList: function () {
        this.templatellist.forEach(res => {
          res.lastDate = formatData(res.lastDate)
        })
        return this.templatellist
      }
    },
    methods: {
      ...FileTemplate,
      // 修改模板\
      towatch (val, type) {
        this.$refs.joinInquirySheetRefs.onInitial(val, type)
      },
      getInit () {
        const { handleAll } = this
        // 获取所有的文件模版操作
        handleAll().then(res => {
          this.templatellist = res.data.obj
        })
      },

      onExchange (row, type) {
        this.$refs.joinInquirySheetRefs.onInitial(row, type)
      },
      // 发起收款
      onInitiateCollection () {
        this.$router.push({ name: 'initiateCollection' })
      },
      // 设置头部背景色
      tableHeader ({ rowIndex }) {
        return this.$tableHeader(rowIndex)
      },
      // 收款申请详情
      onDetails () {
        this.$router.push({ name: 'collectionApplicationDetails' })
      }
      // 页数
    }
  }
</script>
<style
  lang="scss"
  scoped>
</style>
